const fontWeight = {
  bold: 700,
  medium: 500,
  normal: 400,
};

export { fontWeight };
